






















































































import Vue from "vue";
import PlayerSlotInterface from "@/types/PlayerSlotInterface";
import { PersistedEntity } from "@/types";
import SlotTag from "@/types/SlotTag";
import SlotTagService from "@/classes/SlotTagService";

export default Vue.extend({
  name: "SlotTagEditDialog",
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    playerSlot: {
      type: Object as () => PlayerSlotInterface & PersistedEntity,
      required: true,
    },
  },
  data() {
    return {
      selectedTags: [] as SlotTag[],
      availableTags: [] as SlotTag[],
      loadingTags: false,
      saving: false,
    };
  },
  watch: {
    async showDialog(newVal) {
      if (newVal) {
        await this.loadTags();
        this.selectedTags = this.playerSlot.tags
          ? this.playerSlot.tags
              .map((tag) =>
                typeof tag === "string"
                  ? this.availableTags.find((t) => t.name === tag)
                  : tag
              )
              .filter((tag): tag is SlotTag => tag !== undefined)
          : [];
      }
    },
  },
  methods: {
    async loadTags() {
      try {
        this.loadingTags = true;
        this.availableTags = await SlotTagService.getAll();
      } catch (error) {
        this.$store.dispatch("showErrorSnackbar", "Failed to load slot tags.");
      } finally {
        this.loadingTags = false;
      }
    },
    getTagColor(tagName: string): string {
      return SlotTagService.getTagColor(tagName);
    },
    getTagIcon(tagName: string): string {
      return SlotTagService.getTagIcon(tagName);
    },
    removeTag(tag: SlotTag) {
      this.selectedTags = this.selectedTags.filter((t) => t.name !== tag.name);
    },
    close() {
      this.$emit("update:showDialog", false);
    },
    async save() {
      try {
        this.saving = true;

        // Update the slot with new tags
        const slotEndpoint = "/arma/slots/";
        await this.axios.patch(slotEndpoint + this.playerSlot.id, {
          tags: this.selectedTags.map((tag) => tag.name),
        });

        this.$emit("tags-updated");
        this.close();
      } catch (error) {
        this.$store.dispatch("showErrorSnackbar", "Failed to update slot tags.");
      } finally {
        this.saving = false;
      }
    },
  },
});
